export default "__VITE_ASSET__DpD2GM_k__"